import { render, staticRenderFns } from "./Sun.vue?vue&type=template&id=233f37e7"
import script from "./Sun.vue?vue&type=script&lang=js"
export * from "./Sun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports